import { render, staticRenderFns } from "./loginViaOtp.vue?vue&type=template&id=5ed3ab16&scoped=true&"
import script from "./loginViaOtp.vue?vue&type=script&lang=babel&"
export * from "./loginViaOtp.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3ab16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VOtpInput})
